// NIGHT-DIRECTSTAFF-2026-10-23c §4: "Mark as test" on a candidate, like a lead's (lib/testMark.js). Columns
// (migrations/2026-10-23-candidates-test-mark.sql, filed for the hub, additive): candidates.test_marked_at / test_marked_by.
// A marked candidate is out of the lists, counts, Today and the duplicate check; "Show tests" (the same per-device toggle as
// the leads') brings it back into the Candidates list only. Never deleted; "Not a test" undoes it. Until the columns exist the
// action is hidden (one probe), so a button whose write cannot land never shows.
import { testMarkPatch, isTestMarked } from './testMark';

export { isTestMarked };
export async function probeCandidateTestCols(client) {
  try { const { error } = await client.from('candidates').select('test_marked_at,test_marked_by', { head: true }).limit(0); return !error; } catch { return false; }
}
/** Mark or unmark one candidate; RLS refusing is zero rows, never "saved". -> the patch applied */
export async function markCandidateTest(client, candidateId, marked, by = '', now = () => new Date()) {
  const patch = testMarkPatch(marked, by, now);
  const { data, error } = await client.from('candidates').update(patch).eq('id', candidateId).select('id');
  if (error) throw new Error(error.message || 'Could not save');
  if (!Array.isArray(data) || data.length !== 1) throw new Error('Not saved: the database did not accept the change (are you signed in?)');
  return patch;
}
